import { GenericForm } from '@core/forms/form-group-extensions';
import { Classification, IStandard } from '../../../../shared/models/standards/standard';
import { CosmoBaseModel } from '../base/cosmo-base.model';

export type StandardGroupForm = GenericForm<IStandardGroup>;

export interface IStandardGroup {
  id: string | null;
  title: string;
  owner: StandardGroupOwnerEnum;
  parentId: string | null;
  parentName: string | null;
  description: string | null;
  startDate: Date | null;
  endDate: Date | null;
  allowSameStandardInMultipleSubgroups: boolean;
  isActive: boolean;
  isReadonly: boolean;
  publishToWeb: boolean;
  passToEqa: boolean;
  type?: StandardGroupTypeEnum;

  sg: SgReference;
  associatedClassificationRecords: StandardGroupAssociatedClassificationRecord;
  associatedStandardRecords: StandardGroupAssociatedStandardRecord;
}

export class StandardGroup implements IStandardGroup {
  constructor(obj?: IStandardGroup) {
    Object.assign(this, obj);
  }
  id: string | null = null;
  title: string;
  sg: SgReference;
  owner: StandardGroupOwnerEnum;
  parentId: string | null = null;
  parentName: string | null = null;
  description: string | null = null;
  startDate: Date | null = null;
  endDate: Date | null = null;
  allowSameStandardInMultipleSubgroups: boolean = false;
  isActive: boolean = true;
  isReadonly: boolean;
  publishToWeb: boolean = false;
  passToEqa: boolean = false;
  type?: StandardGroupTypeEnum;
  associatedClassificationRecords: StandardGroupAssociatedClassificationRecord;
  associatedStandardRecords: StandardGroupAssociatedStandardRecord;
}

function getDisplayName(type: StandardGroupTypeEnum): string {
  switch (type) {
    case StandardGroupTypeEnum.LearningArea:
      return 'Learning Area';
    case StandardGroupTypeEnum.Moderation:
      return 'Moderation';
    case StandardGroupTypeEnum.SegSubjectGroups:
      return 'SEG Subject Groups';
    case StandardGroupTypeEnum.QualificationRule:
      return 'Qualification Rule';
    case StandardGroupTypeEnum.TopScholarProject:
      return 'Top Scholar Subject';
    case StandardGroupTypeEnum.UniversityEntrance:
      return 'University Entrance';
    case StandardGroupTypeEnum.VisualArt:
      return 'Visual Art';
    default:
      throw new Error('Type not found');
  }
}

export interface IPatchStandardGroupAssociations extends CosmoBaseModel {
  id: string;
  sg: SgReference;
  associatedClassificationRecords?: StandardGroupAssociatedClassificationRecord;
  associatedStandardRecords?: StandardGroupAssociatedStandardRecord;
}

export enum StandardGroupTypeEnum {
  LearningArea = 9401,
  Moderation = 9402,
  SegSubjectGroups = 9403,
  QualificationRule = 9404,
  TopScholarProject = 9405,
  UniversityEntrance = 9406,
  VisualArt = 9407
}

export interface SgReference {
  id: string;
  name: string;
}

export enum StandardGroupOwnerEnum {
  IndustryTrainingOrganisation = 9501,
  SecondaryEducationGroup = 9502,
  NotApplicable = 9503,
  TertiaryEducationGroup = 9504
}

export interface StandardGroupAssociatedStandardRecord {
  standards: AssociatedStandard[];
}

export interface AssociatedStandard {
  record: IStandard;
  isDeleted: boolean;
  isNew: boolean;
}

export interface StandardGroupAssociatedClassificationRecord {
  classifications: AssociatedClassification[];
}

export interface AssociatedClassification {
  record: Classification;
  isDeleted: boolean;
  isNew: boolean;
}

export interface StandardGroupAssociatedRecordScheduledRemoval {
  id: string;
  associatedRecordId: string;
  endDate: string | null;
}
